<template>
  <div>
    <router-view></router-view>
    <BottomSheet></BottomSheet>
  </div>
</template>

<script>

import BottomSheet from '../BottomSheet';
import ListDataEditor from '../content/ListDataEditor';
import LocationsList from './LocationsList'

export default {
  name: "DevicesPage",
  components: {
    BottomSheet
  },
  routes: [
    {
      path: "",
      redirect: "/devices/locations/list"
    },
    {      
      path: "list",
      components: {
        default: LocationsList,
      },
      name: "Devices locations list",
    },
    {
      path: "list/:id/data/new",
      components: {
        default: LocationsList,
        bottomEditor: ListDataEditor
      },
      props: {
        default: true,
        bottomEditor: true
      },
      name: "Device locations new"
    },
    {
      path: "list/:id/data/edit/:data_id",
      components: {
        default: LocationsList,
        bottomEditor: ListDataEditor
      },
      props: {
        default: true,
        bottomEditor: true
      },
      name: "Device locations edit"
    },
   
  ]
}
</script>